// import { Box, Button, Container, Paper, Typography } from "@mui/material";
// import { axiosClient } from "../../../../utils/auth.util";
// import React, { useCallback, useEffect, useState } from "react";
// import {
//   useNavigate,
//   useLocation,
// } from "react-router-dom";

// const SubjectiveResult = (props) => {
//   const history = useNavigate();
//   const location = useLocation();
//   const [marks, setMarks] = useState(0);

//   const [examId, setExamId] = useState('')
//   const [subject, setSubject] = useState('')
//   const [resultStatus, setResultStatus] = useState('')
//   const [isTncSubmitted, setIsTncSubmitted] = useState(false)

//   // const [casests, setCasests] = useState("pending");

//   const find_examId = useCallback(async () => {
//     const response = await axiosClient.post(
//       "/tutorweb/find_examId",
//       {
//         tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//       }
//     );

//     if (response.status === 201 || response.status === 200) {
//       console.log(response.data.tutStatus, "<<<< tut status");
//       let status = response.data.tutStatus
//       let obj
//       if (response.data.lastExamId) {
//         obj = response.data.tutor_exam.find(exam => exam.exam_id === response.data.lastExamId)
//         console.log('✌️obj --->', obj);
//         // dispatch(setExamObj(obj))
//         if (status === 'sube') {
//           // examId = response.data.lastExamId;
//           // subject = obj.subject
//           // marks = (+obj.mcqMarks) * 4;
//           // resultStatus = obj.mcqStatus
//           setMarks(obj.sub_marks)
//           setExamId(response.data.lastExamId)
//           setSubject(obj.subject)
//           setResultStatus(obj.subTestStatus)
//           setIsTncSubmitted(response.data.isTncSubmitted)
//           // if (response.data.isTncSubmitted && obj.subTestStatus === 'pass') {
//           //   const setTutStatus = await axios.post(
//           //     // `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorWeb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id
//           //     `https://testapis4.el.r.appspot.com/api/tutorWeb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id
//           //     }`,
//           //     { tutStatus: "db" }
//           //   );
//           //   if (setTutStatus.data) {
//           //     setTimeout(() => {
//           //       history.replace('/tutor_dashboard/resources')
//           //       window.location.reload()
//           //     }, 2000)
//           //   }
//           // }
//         }
//         else if (status === 'mcqs') {
//           history('/register-dashboard/tutor_exam',{replace:true})
//         }
//         else if (status === 'mcqe') {
//           history('/register-dashboard/tutor_exam/submitted',{replace:true})

//         }
//         else if (status === 'subs') {
//           history('/register-dashboard/tutor_exam/subjective_sheet',{replace:true})

//         }
//       }

//     }
//   }, []);
//   useEffect(() => {
//     find_examId()
//   }, [])
//   // const re_attempt = useCallback(async () => {
//   //   const response = await axios.post(
//   //     "http://localhost:8600/api/tutorWeb/find_examId",
//   //     { tutorId: tutorId }
//   //   );

//   //   if (response.status === 201 || response.status === 200) {
//   //     console.log(response.data.tutStatus, "<<<< tut status");
//   //     // setSubList(response.data.lastSubject);
//   //     // setExamId(response.data.examId);
//   //   }
//   // }, [tutorId]);

//   // useEffect(() => {
//   //   re_attempt();
//   // }, [re_attempt]);

//   return (
//     <div className="max-w-screen-md mx-auto " style={{ marginTop: "7.5rem" }}>
//       <Container>
//         <Paper
//           elevation={5}
//           sx={{
//             padding: "20px 0",
//           }}
//         >
//           <Box
//             sx={{
//               borderBottom: "2px solid black",
//               padding: "10px 0",
//             }}
//           >
//             <Typography
//               sx={{
//                 textAlign: "center",
//                 fontFamily: "Poppins",
//                 fontWeight: "bold",
//                 color: "black",
//                 fontSize: "24px",
//               }}
//             >
//               Subjective Result
//             </Typography>
//           </Box>
//           <Box sx={{}}>
//             <div
//               role="main"
//               className="mx-12"
//             //   class="form-all form-desc-end"
//             // style={{ marginLeft: "27%", marginTop: "11rem", width: "50%" }}
//             >
//               <ul class="form-section page-section">
//                 <li>
//                   <div id="cid_13" class="form-input-wide">
//                     <div id="text_13" class="form-html" data-component="text">
//                       <div
//                         style={{
//                           textAlign: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <strong style={{ color: "darkorange" }}>
//                           You have successfully submitted
//                         </strong>
//                         <div
//                           style={{
//                             marginTop: "10%",
//                             marginBottom: "5%",
//                             backgroundColor: "#f2ffff",
//                           }}
//                         >
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <span style={{ flex: "50%" }}> Exam Id : </span>
//                             <p style={{ flex: "50%" }}>{examId}</p>
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <span style={{ flex: "50%" }}> Subject : </span>
//                             <p style={{ flex: "50%" }}>{subject}</p>
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <span style={{ flex: "50%" }}> Marks : </span>
//                             <p style={{ flex: "50%" }}>
//                               {marks === 0 ? '-' : marks} / 100
//                             </p>
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               justifyContent: "center",
//                             }}
//                           >
//                             <span style={{ flex: "50%" }}> Status : </span>{" "}
//                             <p
//                               style={{
//                                 color:
//                                   resultStatus === "pending"
//                                     ? "orange"
//                                     : resultStatus === "pass" ? "green"
//                                       : "red",
//                                 flex: "50%",
//                               }}
//                             >
//                               {resultStatus}
//                             </p>
//                           </div>
//                         </div>

//                         {resultStatus === "pass" ? (
//                           <span style={{ color: "green" }}>
//                             Congrats!! You have qualified this test
//                             {!isTncSubmitted ? <div
//                               style={{
//                                 marginTop: "10px",
//                                 marginBottom: "30px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <Button
//                                 variant="contained"
//                                 className="ctaBtn"
//                                 onClick={() =>
//                                   history("/register-dashboard/tutor_exam/terms_condition",{replace:true})
//                                 }
//                                 style={{
//                                   background:
//                                     "linear-gradient(127deg, #03D757, #11A1DC)",
//                                   borderRadius: "35px",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Proceed To Terms & Conditions
//                               </Button>
//                             </div> :
//                               <div
//                                 style={{
//                                   marginTop: "10px",
//                                   marginBottom: "30px",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <Button
//                                   variant="contained"
//                                   className="ctaBtn"
//                                   onClick={async () => {
//                                     const setTutStatus = await axiosClient.post(
//                                       `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`,
//                                       { tutStatus: "db" }
//                                     );
//                                     if (setTutStatus.data) {
//                                       let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//                                       let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;
//                                       let temp_tutorSaveObj = {
//                                         ...tutor_ls,
//                                         tutStatus: "db",
//                                       };
//                                       console.log({ tutor_ls });
//                                       let temp_tutorObj = {
//                                         ...tutor1,
//                                         saveTutor: temp_tutorSaveObj,
//                                       };
//                                       let tutor_stringified = JSON.stringify(temp_tutorObj);
//                                       console.log({ temp_tutorObj });
//                                       localStorage.setItem("tutor", tutor_stringified);
//                                     history('/register-dashboard',{replace:true})
//                                       window.location.reload()               
//                                     }
//                                   }
//                                   }
//                                   style={{
//                                     background:
//                                       "linear-gradient(127deg, #03D757, #11A1DC)",
//                                     borderRadius: "35px",
//                                     fontSize: "15px",
//                                   }}
//                                 >
//                                   Return to dashboard
//                                 </Button>
//                               </div>
//                             }

//                           </span>

//                         ) : resultStatus === "fail" ?
//                           < span style={{ color: "red" }}>
//                             Sorry, you could not pass the test
//                             <div
//                               style={{
//                                 marginTop: "10px",
//                                 marginBottom: "30px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <Button
//                                 variant="contained"
//                                 className="ctaBtn"
//                                 onClick={async () => {
//                                   const setTutStatus = await axiosClient.post(
//                                     `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`,
//                                     { tutStatus: "subs" }
//                                   );
//                                   if (setTutStatus.data) {
//                                     history("/register-dashboard/tutor_exam/subjective_sheet",{replace:true});
//                                     // window.location.reload();
//                                   }

//                                 }
//                                 }
//                                 style={{
//                                   background:
//                                     "linear-gradient(127deg, #03D757, #11A1DC)",
//                                   borderRadius: "35px",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Reattempt subjective test
//                               </Button>
//                             </div>
//                             <div
//                               style={{
//                                 marginTop: "10px",
//                                 marginBottom: "30px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <Button
//                                 variant="contained"
//                                 className="ctaBtn"
//                                 onClick={async () => {
//                                   const setTutStatus = await axiosClient.post(
//                                     `/tutorweb/setTutStatus/${JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id}`,
//                                     { tutStatus: "db" }
//                                   );
//                                   if (setTutStatus.data) {
//                                     history("/register-dashboard/tutor_exam",{replace:true});
//                                     // window.location.reload();
//                                   }
//                                 }
//                                 }
//                                 style={{
//                                   background:
//                                     "linear-gradient(127deg, #03D757, #11A1DC)",
//                                   borderRadius: "35px",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Choose another subject
//                               </Button>
//                             </div>

//                           </span> :
//                           <span style={{ color: "gray" }}>
//                             We have recieved your answer. You will be shortly
//                             notified.
//                             <div
//                               style={{
//                                 marginTop: "10px",
//                                 marginBottom: "30px",
//                                 textAlign: "center",
//                               }}
//                             >
//                             {resultStatus &&   <Button
//                                 variant="contained"
//                                 disabled={resultStatus !== "pending" ? false : true}
//                                 className="ctaBtn"
//                                 onClick={() =>
//                                   history("/register-dashboard/tutor_exam/terms_condition",{replace:true})
//                                 }
//                                 style={{
//                                   background:
//                                     "linear-gradient(127deg, #03D757, #11A1DC)",
//                                   borderRadius: "35px",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Proceed To Terms & Conditions
//                               </Button>}
//                             </div>
//                           </span>
//                         }

//                         {/* {resultStatus === "pending" && (
//                           <span style={{ color: "gray" }}>
//                             We have recieved your answer. You will be shortly
//                             notified.
//                             <div
//                               style={{
//                                 marginTop: "10px",
//                                 marginBottom: "30px",
//                                 textAlign: "center",
//                               }}
//                             >
//                               <Button
//                                 variant="contained"
//                                 disabled={resultStatus === "pending" ? true : false}
//                                 className="ctaBtn"
//                                 onClick={() =>
//                                   history.replace("/tutor_exam/terms_condition")
//                                 }
//                                 style={{
//                                   background:
//                                     "linear-gradient(127deg, #03D757, #11A1DC)",
//                                   borderRadius: "35px",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Proceed To Terms & Conditions
//                               </Button>
//                             </div>
//                           </span>
//                         )} */}
//                       </div>
//                     </div>
//                   </div>
//                 </li>

//                 <li style={{ display: "none" }}>
//                   Should be Empty:
//                   <input type="text" name="website" value="" />
//                 </li>
//               </ul>
//             </div>
//           </Box>
//         </Paper>
//       </Container>
//     </div >
//   );
// };

// export default SubjectiveResult;


import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { axiosClient } from "../../../../utils/auth.util";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../../../redux/slice/registerSlice";
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Chip,
  Alert,
  CircularProgress,
  Divider
} from "@mui/material";
import {
  CheckCircle,
  Cancel,
  Assessment,
  School,
  Description
} from "@mui/icons-material";

const SubjectiveResult = () => {
  const [examData, setExamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Get userData from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);

  const fetchExamResults = useCallback(async () => {
    if (!userData) return;

    setLoading(true);
    try {
      const response = await axiosClient.post("/tutorWeb/find_examId", {
        tutorId: userData.tutor_id || userData._id,
      });

      if (response.status === 200 || response.status === 201) {
        const { tutStatus, lastExamId, tutor_exam } = response.data;
        
        if (lastExamId && tutor_exam) {
          const examResult = tutor_exam.find(exam => exam.exam_id === lastExamId);
          if (examResult) {
            setExamData({
              ...examResult,
              tutStatus,
              examId: lastExamId
            });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching exam results:", error);
      setError("Failed to load exam results");
    } finally {
      setLoading(false);
    }
  }, [userData]);

  useEffect(() => {
    fetchExamResults();
  }, [fetchExamResults]);

  const goToDashboard = async () => {
    // Update Redux state instead of localStorage
    dispatch(updateUserData({ tutStatus: "db" }));

    try {
      const res = await axiosClient.post(
        `/tutorweb/setTutStatus/${userData.tutor_id || userData._id}`,
        { tutStatus: "db" }
      );

      if (res.data) {
        navigate("/register-dashboard", { replace: true });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      navigate("/register-dashboard", { replace: true });
    }
  };

  const getStatusColor = (status) => {
    return status === "pass" ? "success" : "error";
  };

  const getStatusIcon = (status) => {
    return status === "pass" ? <CheckCircle /> : <Cancel />;
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ ml: 2 }}>
            Loading exam results...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (error || !examData) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error">
          {error || "No exam data available"}
        </Alert>
        <Box mt={2}>
          <Button variant="contained" onClick={() => navigate("/register-dashboard")}>
            Return to Dashboard
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box textAlign="center" mb={4}>
          <Typography variant="h3" component="h1" gutterBottom>
            Subjective Test Results
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Your assessment has been completed
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Result Summary Card */}
          <Grid item xs={12}>
            <Card elevation={2}>
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Assessment color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h5">
                    Exam Summary
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Exam ID:</strong> {examData.examId}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Subject:</strong> {examData.subject}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>MCQ Score:</strong> {(+examData.marks * 4)}/100
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body1" sx={{ mr: 1 }}>
                        <strong>MCQ Status:</strong>
                      </Typography>
                      <Chip
                        icon={getStatusIcon(examData.status)}
                        label={examData.status?.toUpperCase()}
                        color={getStatusColor(examData.status)}
                        variant="outlined"
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" gutterBottom>
                  Subjective Assessment Status
                </Typography>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Terms & Conditions:</strong> Completed
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Overall Status:</strong> 
                      <Chip 
                        label="Assessment Complete" 
                        color="success" 
                        size="small" 
                        sx={{ ml: 1 }}
                      />
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Candidate Information */}
          <Grid item xs={12}>
            <Card elevation={2}>
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <School color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h5">
                    Candidate Information
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Name:</strong> {userData?.fullName || userData?.name || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Email:</strong> {userData?.email || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Department:</strong> {userData?.department || 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Degree:</strong> {userData?.highest_degree || 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Assessment Details */}
          <Grid item xs={12}>
            <Card elevation={2}>
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Description color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h5">
                    Assessment Details
                  </Typography>
                </Box>

                <Alert severity="success" sx={{ mb: 2 }}>
                  You have successfully completed the subjective assessment portion of your tutor registration.
                </Alert>

                <Typography variant="body2" color="text.secondary" paragraph>
                  Your submission includes:
                </Typography>
                
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                  <li>
                    <Typography variant="body2">
                      Multiple Choice Questions (MCQ) - Score: {(+examData.marks * 4)}/100
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      Terms & Conditions Agreement - Status: Completed
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body2">
                      Subject Expertise Verification - Subject: {examData.subject}
                    </Typography>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Box mt={4} display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            onClick={goToDashboard}
            size="large"
            sx={{ 
              px: 4, 
              py: 1.5,
              borderRadius: 2,
              background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              '&:hover': {
                background: 'linear-gradient(45deg, #1976D2 30%, #1BA0E3 90%)',
              }
            }}
          >
            Return to Dashboard
          </Button>
        </Box>

        {/* Next Steps Information */}
        <Box mt={4}>
          <Card elevation={1}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                What's Next?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Congratulations! You have completed all required assessments. 
                Your application is now under review by our team. You will receive 
                an email notification once the review process is complete. 
                Please return to your dashboard to monitor your application status.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Paper>
    </Container>
  );
};

export default SubjectiveResult;
